/** @format */

import { Spin } from "antd";
import * as _ from "lodash";
import { useEffect } from "react";
import { toast } from "react-toastify";

import axiosInstance from "../../lib/axios";
import { useAuthState } from "../../state/useAuthState";
import { useGeneralState } from "../../state/useGeneralState";
import Card from "../Card";
import Header from "../Header";
import { PaymentMethod, PaymentOnlyMethod } from "../PaymentMethods";

const StripeForm = ({
    amount,
    currency,
    onPaymentSuccess,
    stripeId,
    merchantId,
    setNameGlobal,
    customerName,
    customerEmail,
    onlyAllowedPayment,
    alpha2CountryCode,
    reference,
    description,
    productsAndAmount,
    isGiftAid,
    merchantDetails,
}) => {
    const { setClientSecret, clientSecret } = useAuthState();
    const { transactionBaseUrl, method } = useGeneralState();

    useEffect(() => {
        const initStripe = async () => {
            try {
                // const resultVal = JSON.parse(description);

                const keys = {};
                const comments = {};

                // Object.keys(resultVal).map((i) => {
                //     if (Number(resultVal[i]?.amount) <= 0) {
                //         return;
                //     }
                //     keys[i] = parseFloat(resultVal[i]?.amount).toFixed(2);
                //     comments[i] = resultVal[i]?.comment || "";
                // });
                const source = productsAndAmount && typeof productsAndAmount === "object" && !Array.isArray(productsAndAmount)
                    ? productsAndAmount
                    : (() => {
                        let descObj = description;
                        if (typeof description === "string") {
                            try { descObj = JSON.parse(description); } catch (_) {}
                        }
                        return descObj;
                    })();

                if (source && typeof source === "object" && !Array.isArray(source)) {
                    Object.entries(source).forEach(([productId, value]) => {
                        const amt = Number(value?.amount ?? 0);
                        if (amt && amt !== 0) {
                            comments[productId] = value?.comment || "";
                            keys[productId] = amt;
                        }
                    });
                }

                const result = await axiosInstance.post(
                    `${transactionBaseUrl}stripe/payment-intent?amount=${Number(
                        amount
                    ).toFixed(3)}&currency=${currency.code}`,
                    {
                        merchant_id: merchantId,
                        stripeId,
                        reference: reference,
                        customerName,
                        customerEmail,
                        isGiftAid: isGiftAid === true ? 1 : 0,
                        paymentType: PaymentOnlyMethod.card,
                        alpha2CountryCode: alpha2CountryCode,
                        description: JSON.stringify(keys),
                        comments,
                    }
                );

                const data = result.data;

                if (data?.error?.message) {
                    toast.warning(data?.error?.message?.raw?.message);
                    return;
                }

                setClientSecret(data.client_secret);
            } catch (e) {
                if (method === PaymentMethod.PayWithCard) {
                    toast.warning(
                        e?.response?.data?.error?.message ??
                            "Error initializing payment"
                    );
                }
            }
        };

        initStripe();
    }, [method, amount]);

    if (
        _.isEmpty(clientSecret) ||
        _.isNull(clientSecret) ||
        _.isUndefined(clientSecret)
    ) {
        return (
            <div className="payment-section m-auto mt-12">
                <div
                    className={`${onlyAllowedPayment ? "hidden md:flex" : ""}`}>
                    <Header
                        title={
                            merchantDetails?.ent_type === "RELIGIOUS"
                                ? "Give with Debit/ Credit Card"
                                : "Pay with Debit/ Credit Card"
                        }
                    />
                </div>

                <div className="w-full flex justify-center p-5">
                    <Spin style={{ alginSelf: "center" }} />;
                </div>
            </div>
        );
    }

    return (
        <Card
            onPaymentSuccess={onPaymentSuccess}
            country={currency.code}
            stripeId={stripeId}
            onlyAllowedPayment={onlyAllowedPayment}
            setNameGlobal={setNameGlobal}
            alpha2CountryCode={alpha2CountryCode}
            customerEmail={customerEmail}
            customerName={customerName}
            merchantDetails={merchantDetails}
        />
    );
};

export default StripeForm;
